import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const TrackableLinkGroupPermissionGate = (props: Omit<BasePermissionGateProps<"trackable-link">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="trackable-link"
		/>
	)
}

export default TrackableLinkGroupPermissionGate
